import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { activityService } from "./services/activity.service";
import ActivityTable from "./ActivityTable";
import ActivityForm from "./ActivityForm";
import { toast } from "react-toastify";
import ConfirmationModal from "../../Shared/ConfirmationModal";

const initialFetchingState = {
  fetching: false,
  fetched: false,
  activities: null,
  error: null,
  filterParams: null,
  pages: null,
  pageNum: 0,
  pageSize: 10
};

const initialSubmitState = {
  submitting: false,
  submitted: false,
  formResponse: null,
  formError: null,
  hasParams: false,
  isView: false
};

const initailGetState = {
  fetchingActivity: false,
  fetchedActivity: false,
  fetchingError: null,
  selectedRow: null
};

class ManageActivities extends Component {
  state = {
    ...initialFetchingState,
    ...initialSubmitState,
    ...initailGetState,
    showNextJoyRide:false,
    showJoyRideOnTable:false
  };

  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getActivities({ pageNum, pageSize });
    if (this.props.location.state) {
      const { run } = this.props.location.state;
     
      if (run) {
        
        this.setState({ showNextJoyRide: run });
      } else {
        return;
      }
    }
  }

  getActivities = async params => {
    this.setState({
      ...this.state,
      fetching: true
    });
    try {
      let response = await activityService.getAllActivities(params);
      if (response) {
      
        this.setState({
          ...this.state,
          fetching: false,
          fetched: true,
          activities: response,
          pages: Math.ceil(response.count / params.pageSize),
          error: null
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetching: false,
        fetched: false,
        error
      });
    }
  };

  getActivity = async (params, action) => {
    this.setState({
      ...this.state,
      ...initialSubmitState,
      fetchingActivity: true,
      fetchingError: null
    });
    try {
      let response = await activityService.getActivity(params);
      if (response) {
  
        this.setState({
          ...this.state,
          ...initialSubmitState,
          fetchingActivity: false,
          fetchedActivity: true,
          hasParams: true,
          isView: action === "view" ? true : false,
          selectedRow: response
        });
        
      }
    } catch (error) {
      this.setState({
        ...this.state,
        ...initialSubmitState,
        fetchingActivity: false,
        fetchedActivity: false,
        fetchingError: error,
        selectedRow: null
      });
    }
  };

  addActivity = async requestBody => {
    const { pageSize, selectedRow } = this.state;

    this.setState({
      ...this.state,
      submitting: true,
      submitted: false,
      formResponse: null,
      formError: null
    });
    try {
      let response = await activityService.addActivity(
        requestBody,
        selectedRow && selectedRow.id
      );
      if (response) {
        this.setState({
          ...this.state,
          submitting: false,
          submitted: true,
          formResponse: response,
          formError: null
        });
        this.getActivities({ pageNum: 1, pageSize });
        toast.success(
          `Activity ${selectedRow ? "updated" : "created"} successfully`,
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          }
        );
        selectedRow && this.resetButton();
      }
    } catch (error) {
      this.setState({
        ...this.state,
        formError: error,
        submitting: false
      });
    }
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getActivities(params);
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };

  selectRow = (selectedRow, action) => {
    this.getActivity(selectedRow.original.id, action);
  };

  resetButton = () => {
    this.setState({
      hasParams: false,
      submitting: false,
      selectedRow: null,
      submitted: false,
      isView: false
    });
  };

  showConfirmation = selectedRow => {
    this.setState({
      selectedRow: selectedRow.original,
      showModal: !this.state.showModal
    });
  };
//===========================TOUR GUIDE SECTION==================//
setNextJoyRide=()=>{
  this.setState({showNextJoyRide:false})
}

startJoyRideAtDataTable=()=>{
 this.setState({showJoyRideOnTable:true})
}

stopJoyRideAtDataTable=()=>{
  this.setState({showJoyRideOnTable:false})
 }

 routeChange = () => {
  this.props.history.push({
    pathname: `/events`,
    state: { run: true },
  });
};
  render() {
    const {
      fetching,
      fetched,
      activities,
      pages,
      pageNum,
      pageSize,
      error,
      submitting,
      submitted,
      hasParams,
      selectedRow,
      formError,
      fetchingActivity,
      fetchedActivity,
      fetchingError,
      isView,
      showNextJoyRide,
      showJoyRideOnTable
    } = this.state;

    return (
      <div>
        <Row>
          <Col sm="4">
            <ActivityForm
              submitting={submitting}
              error={formError}
              hasParams={hasParams}
              selectedRow={selectedRow}
              submitAction={this.addActivity}
              reset={this.resetButton}
              submitted={submitted}
              isView={isView}
              fetchingActivity={fetchingActivity}
              fetchedActivity={fetchedActivity}
              fetchingError={fetchingError}
              showNextJoyRide={showNextJoyRide}
              setNextJoyRide={this.setNextJoyRide}
              startJoyRideAtDataTable={this.startJoyRideAtDataTable}
            />
          </Col>
          <Col sm="8">
            <ActivityTable
              fetching={fetching}
              fetched={fetched}
              data={activities}
              pages={pages}
              page={pageNum}
              pageSize={pageSize}
              error={error}
              filterData={this.filterData}
              DeleteModal={this.DeleteModal}
              showModal={this.showConfirmation}
              setPageNumber={this.setPageNumber}
              setPageSize={this.setPageSize}
              selectRow={this.selectRow}
              routeChange={this.routeChange}
              showJoyRideOnTable={showJoyRideOnTable}
              stopJoyRideAtDataTable={this.stopJoyRideAtDataTable}
            />
          </Col>
          <ConfirmationModal
            isOpen={this.state.showModal}
            showModal={this.showConfirmation}
            action={() => null}
            item={selectedRow}
          />
        </Row>
      </div>
    );
  }
}

export default ManageActivities;
